import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=0c0c8a60&"
import script from "./Radio.vue?vue&type=script&lang=js&"
export * from "./Radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0c0c8a60', component.options)
    } else {
      api.reload('0c0c8a60', component.options)
    }
    module.hot.accept("./Radio.vue?vue&type=template&id=0c0c8a60&", function () {
      api.rerender('0c0c8a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Misc/Radio.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Misc/Radio.vue
// module id = ahne
// module chunks = 0